import { Component } from '@angular/core';

@Component({
	selector: 'app-intro-auth-modal',
	templateUrl: './intro-auth-modal.component.html',
})
export class IntroAuthModalComponent {}
